import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import Select from 'react-select'
import {
	appAllGetPermission,
	appAllGetTeams,
	appCreateTeams,
	appDeleteTeams,
	appUpdateTeams,
} from '../../store/teams'
import { appGetAllUser } from '../../store/user'
import { designationOptions } from '../../common/jsonData'

function TableFilter() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const params = useParams()
	const [page, setPage] = useState(params.page || 1)
	const [showModal, setShowModal] = useState(false)
	const [editMode, setEditMode] = useState(false)
	const [editData, setEditData] = useState(null)
	const [formData, setFormData] = useState({
		mobile: '',
		designation: '',
	})
	const [selectedPermissions, setSelectedPermissions] = useState({})
	const [permissionError, setPermissionError] = useState('')
	const [isDurationEnabled, setIsDurationEnabled] = useState(false)
	const [duration, setDuration] = useState({ from: '', to: '' })
	const [designationError, setDesignationError] = useState('')
	const [durationError, setDurationError] = useState('')
	const [userError, setUserError] = useState('')

	const { isloder, teams: teamsList } = useSelector(state => state.teamsReducer)
	//console.log(teamsList)
	const permissionList = useSelector(state => state.teamsReducer.permission)
	const isdeleted = useSelector(state => state.teamsReducer.isdeleted)
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')

	const designationIndex = designationOptions.findIndex(opt => opt.value === formData.designation)
	const users = useSelector(state => state?.usersReducer.users)

	useEffect(() => {
		// if (!teamsList || teamsList.length === 0) {
		dispatch(
			appAllGetTeams({
				page,
				limit: 10,
				sanstha: sansthaId || permissionOfSanstha,
			}),
		)
		// }
		navigate(`/teams/${page}`)
	}, [page])

	useEffect(() => {
		dispatch(appAllGetPermission())
		dispatch(
			appGetAllUser({
				page: 1,
				limit: 1000,
				sansthaId: sansthaId || permissionOfSanstha,
			}),
		)
	}, [sansthaId || permissionOfSanstha])

	useEffect(() => {
		if (isdeleted) {
			dispatch(
				appAllGetTeams({
					page,
					limit: 10,
					sanstha: sansthaId || permissionOfSanstha,
				}),
			)
		}
	}, [isdeleted])

	const handlePermissionChange = (permissionId, label) => {
		const newPermissions = {
			...selectedPermissions,
			[permissionId]: !selectedPermissions[permissionId],
		}
		setSelectedPermissions(newPermissions)
		// Clear error if at least one permission is selected
		if (Object.values(newPermissions).some(value => value)) {
			setPermissionError('')
		}
	}

	const handleEdit = item => {
		//	console.log(item)
		setEditMode(true)
		setEditData(item)

		// figure out where userId comes from
		const isHub = item?.userType === 'hub' || item?.hub
		const userId = isHub ? item?.userId?._id : item?._id

		setFormData({
			user: userId || '',
			mobile: item.mobile || (isHub ? item?.userId?.mobile : item?.mobile) || '',
			designation: item.designation || item?.joinedSanstha?.[0]?.designation || '',
		})

		// Set selected permissions
		const initialPermissions = {}
		const permissions = isHub ? item.permissions : item?.joinedSanstha?.[0]?.permissions || []
		//	console.log(permissions)
		permissions.forEach(perm => {
			initialPermissions[perm._id] = true
		})
		setSelectedPermissions(initialPermissions)

		if (item.from && item.to) {
			setIsDurationEnabled(true)
			setDuration({
				from: item.from || '',
				to: item.to || '',
			})
		} else if (item?.joinedSanstha?.[0]?.from && item?.joinedSanstha?.[0]?.to) {
			setIsDurationEnabled(true)
			setDuration({
				from: item.joinedSanstha[0].from || '',
				to: item.joinedSanstha[0].to || '',
			})
		} else {
			setIsDurationEnabled(false)
			setDuration({ from: '', to: '' })
		}

		setShowModal(true)
	}

	// const handleSubmit = e => {
	// 	e.preventDefault()

	// 	const selectedPerms = Object.entries(selectedPermissions)
	// 		.filter(([_, isSelected]) => isSelected)
	// 		.map(([id]) => id)

	// 	const payload = {
	// 		mobile: formData.mobile,
	// 		permissions: [],
	// 		designation: '',
	// 		sort: 0,
	// 		userType: 'sanstha',
	// 		inactive: false,
	// 		sanstha: sansthaId || permissionOfSanstha,
	// 		userId: formData.user,
	// 	}

	// 	// if (!/^\d{10}$/.test(formData.mobile)) {
	// 	//   setMobileError("Mobile number must be exactly 10 digits.");
	// 	//   return;
	// 	// } else {
	// 	//   setMobileError("");
	// 	// }

	// 	// Case 1: Previous Committees
	// 	if (isDurationEnabled) {
	// 		if (!formData.designation) {
	// 			setDesignationError('Required ')
	// 			return
	// 		}
	// 		setDesignationError('')

	// 		payload.designation = formData.designation
	// 		payload.sort = designationIndex
	// 		payload.permissions = []
	// 		payload.from = duration.from
	// 		payload.to = duration.to
	// 		payload.inactive = true
	// 		// payload.sanstha = sansthaId;

	// 		if (!duration.from || !duration.to) {
	// 			setDurationError('Required')
	// 			return
	// 		}
	// 		// setDurationError("");
	// 	} else {
	// 		if (selectedPerms.length === 0) {
	// 			setPermissionError('Please select at least one permission.')
	// 			return
	// 		}
	// 		setPermissionError('')

	// 		payload.permissions = selectedPerms
	// 		payload.designation = formData.designation
	// 		payload.sort = designationIndex
	// 		// payload.sanstha = sansthaId;
	// 		// payload.from = undefined;
	// 		// payload.to = undefined;
	// 	}

	// 	if (editMode) {
	// 		dispatch(appUpdateTeams({ _id: editData._id, ...payload }))
	// 			.unwrap?.()
	// 			.then(() => {
	// 				dispatch(
	// 					appAllGetTeams({
	// 						page,
	// 						limit: 10,
	// 						sanstha: sansthaId || permissionOfSanstha,
	// 					}),
	// 				)

	// 				// Reset AFTER success
	// 				setShowModal(false)
	// 				setEditMode(false)
	// 				setEditData(null)
	// 				setFormData({
	// 					mobile: '',
	// 					designation: '',
	// 				})
	// 				setSelectedPermissions({})
	// 				setDuration({ from: '', to: '' })
	// 			})
	// 			.catch(err => {
	// 				console.error('Update failed:', err)
	// 			})
	// 	} else {
	// 		dispatch(appCreateTeams(payload))
	// 			.then(() =>
	// 				dispatch(
	// 					appAllGetTeams({
	// 						page,
	// 						limit: 10,
	// 						sanstha: sansthaId || permissionOfSanstha,
	// 					}),
	// 				),
	// 			)
	// 			.catch(err => {
	// 				console.error('Create team error:', err)
	// 			})
	// 	}

	// 	// Reset form
	// 	setShowModal(false)
	// 	setEditMode(false)
	// 	setEditData(null)
	// 	setFormData({
	// 		// firstName: "",
	// 		// lastName: "",
	// 		// email: "",
	// 		mobile: '',
	// 		designation: '',
	// 	})
	// 	setSelectedPermissions({})
	// 	setDuration({ from: '', to: '' })
	// 	setPermissionError('')
	// 	setDesignationError('')
	// }

	const handleSubmit = e => {
		e.preventDefault()

		const selectedPerms = Object.entries(selectedPermissions)
			.filter(([_, isSelected]) => isSelected)
			.map(([id]) => id)

		let isValid = true

		if (!formData.user) {
			setUserError('User is required')
			isValid = false
		} else {
			setUserError('')
		}

		if (!formData.designation) {
			setDesignationError('Designation is required')
			isValid = false
		} else {
			setDesignationError('')
		}

		if (isDurationEnabled) {
			if (!duration.from || !duration.to) {
				setDurationError('Both years are required')
				isValid = false
			} else if (Number(duration.from) > Number(duration.to)) {
				setDurationError('From year cannot be greater than To year')
				isValid = false
			} else {
				setDurationError('')
			}
		} else {
			if (selectedPerms.length === 0) {
				setPermissionError('Please select at least one permission.')
				isValid = false
			} else {
				setPermissionError('')
			}
		}

		if (!isValid) return

		const payload = {
			mobile: formData.mobile,
			permissions: isDurationEnabled ? [] : selectedPerms,
			designation: formData.designation,
			sort: designationIndex,
			userType: 'sanstha',
			inactive: isDurationEnabled,
			sanstha: sansthaId || permissionOfSanstha,
			userId: formData.user,
			...(isDurationEnabled && {
				from: duration.from,
				to: duration.to,
			}),
		}

		if (editMode) {
			dispatch(appUpdateTeams({ _id: editData._id, ...payload }))
				.unwrap?.()
				.then(() => {
					dispatch(
						appAllGetTeams({
							page,
							limit: 10,
							sanstha: sansthaId || permissionOfSanstha,
						}),
					)
				})
		} else {
			dispatch(appCreateTeams(payload)).then(() =>
				dispatch(
					appAllGetTeams({
						page,
						limit: 10,
						sanstha: sansthaId || permissionOfSanstha,
					}),
				),
			)
		}

		setShowModal(false)
		setEditMode(false)
		setEditData(null)
		setFormData({ mobile: '', designation: '', user: '' })
		setSelectedPermissions({})
		setDuration({ from: '', to: '' })
		setPermissionError('')
		setDesignationError('')
		setDurationError('')
		setUserError('')
	}

	const handleDeleteTeams = item => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this team?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				const payload = {
					_id: item?._id,
					mobile: item?.mobile,
					designation: null,
					sort: null,
					userType: 'sanstha',
					inactive: false,
					sanstha: sansthaId || permissionOfSanstha,
					userId: null,
					permissions: [],
					from: null,
					to: null,
				}

				dispatch(appUpdateTeams(payload)).then(() => {
					dispatch(
						appAllGetTeams({
							page,
							limit: 10,
							sanstha: sansthaId || permissionOfSanstha,
						}),
					)
				})
			}
		})
	}

	return (
		<>
			{/* {isloder && <PageLoader />} */}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<button
						className="btn btn-primary mb-3"
						onClick={() => {
							setEditMode(false)
							setEditData(null)
							setFormData({
								firstName: '',
								lastName: '',
								email: '',
								mobile: '',
							})
							setSelectedPermissions({})
							setIsDurationEnabled(false)
							setDuration({ from: '', to: '' })
							setShowModal(true)
						}}
					>
						Add Team
					</button>
					<div className="table-responsive bootgrid">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									{/* <th data-column-id="sender">Email</th> */}
									<th data-column-id="sender">Member</th>
									<th data-column-id="received" data-order="desc">
										Permission
									</th>
									<th data-column-id="received" data-order="desc">
										Previous Comittes
									</th>
									<th data-column-id="received" data-order="desc">
										Designation
									</th>
									<th data-column-id="received" data-order="desc">
										Duration
									</th>
									{/* <th data-column-id="received" data-order="desc">
                    Created Date
                  </th> */}
									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										<div></div>
									</th>
								</tr>
							</thead>
							<tbody>
								{teamsList?.map(item => (
									<tr key={item._id}>
										{/* <td>{item?.email}</td> */}
										<td>
											<img
												src={item.profilePic || '/img/user.jpg'}
												alt="user"
												style={{
													width: '50px',
													height: '50px',
													borderRadius: '50%',
												}}
											/>
											<br />
											{item.firstName} {item.lastName}
											<br />
											<small>{item?.mobile}</small>{' '}
										</td>
										<td
											style={{
												maxWidth: '250px',
												wordWrap: 'break-word',
												whiteSpace: 'normal',
											}}
										>
											{item?.joinedSanstha[0].permissions?.map((place, i) => (
												<span key={i}>
													{place.label}
													{i < item?.joinedSanstha[0].permissions.length - 1 ? ', ' : ''}
												</span>
											))}
										</td>

										<td>
											{item?.joinedSanstha[0]?.inactive ? (
												<span className="badge badge-success">Previous Comittes</span>
											) : null
											// <span className="badge badge-danger">
											//   Inactive
											// </span>
											}
										</td>
										<td>{item?.joinedSanstha[0].designation}</td>
										<td>
											{item.joinedSanstha[0].from}-{item.joinedSanstha[0].to}
										</td>

										{/* <td>
                      {item?.createdAt
                        ? new Date(item.createdAt).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        : "-"}
                    </td> */}
										<td>
											<button
												type="button"
												className="btn btn-sm btn-info mr-2 command-edit"
												onClick={() => handleEdit(item)}
											>
												<em className="fa fa-edit fa-fw"></em>
											</button>
											<button
												type="button"
												className="btn btn-sm btn-danger command-delete"
												data-row-id="10253"
												// onClick={() => handleDeleteTeams(item?._id)}
												onClick={() => handleDeleteTeams(item)}
											>
												<em className="fa fa-trash fa-fw"></em>
											</button>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
					{/* {paginate && (
            <Paginate paginate={paginate} page={page} setPage={setPage} />
          )} */}
				</div>
			</div>

			{showModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						marginTop: '35px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title">{editMode ? 'Edit Team' : 'Add New Team'}</h5>
								<button
									type="button"
									className="close"
									onClick={() => {
										setShowModal(false)
										setEditMode(false)
										setEditData(null)
										setFormData({
											firstName: '',
											lastName: '',
											email: '',
											mobile: '',
										})
										setSelectedPermissions({})
										// setMobileError("");
									}}
								>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
								<form onSubmit={handleSubmit}>
									<div className="row">
										<div className="col-md-6">
											<div className="form-group">
												<label>Select Users</label>
												<Select
													options={
														Array.isArray(users)
															? users.map(user => ({
																	value: user._id,
																	label: user.firstName,
															  }))
															: []
													}
													onChange={option => {
														const selectedUser = Array.isArray(users)
															? users.find(u => u._id === option?.value)
															: null

														if (selectedUser) {
															setFormData(prev => ({
																...prev,
																user: selectedUser._id,
																mobile: selectedUser.mobile,
															}))
														}
													}}
													value={
														Array.isArray(users)
															? users.find(user => user._id === formData.user)
																? {
																		value: formData.user,
																		label: users.find(u => u._id === formData.user)?.firstName,
																  }
																: null
															: null
													}
													placeholder="Select User..."
												/>
											</div>
											{userError && <div className="text-danger mt-2">{userError}</div>}
										</div>
										<div className="col-md-6">
											<div className="form-group">
												<label>Designation </label>
												<Select
													options={designationOptions}
													value={designationOptions.find(opt => opt.value === formData.designation)}
													onChange={option => {
														setFormData(prev => ({
															...prev,
															designation: option.value,
														}))
														setDesignationError('')
													}}
													placeholder="Select Designation..."
													isSearchable
												/>
												{designationError && (
													<div className="text-danger mt-2">{designationError}</div>
												)}
											</div>
										</div>
									</div>
									<div className="form-group">
										<label className="font-weight-bold mb-3">Permissions *</label>
										<div
											className="permissions-grid"
											style={{
												display: 'grid',
												gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
												gap: '10px',
												maxHeight: '200px',
												overflowY: 'auto',
												borderRadius: '4px',
											}}
										>
											{permissionList?.map(permission => (
												<div key={permission._id} className="custom-control custom-checkbox">
													<input
														type="checkbox"
														className="custom-control-input"
														id={`permission-${permission._id}`}
														checked={selectedPermissions[permission._id] || false}
														onChange={() =>
															handlePermissionChange(permission._id, permission.label)
														}
													/>
													<label
														className="custom-control-label"
														htmlFor={`permission-${permission._id}`}
														style={{
															cursor: 'pointer',
															padding: '2px 12px',
														}}
													>
														{permission.label}
													</label>
												</div>
											))}
										</div>
										{permissionError && <div className="text-danger mt-2">{permissionError}</div>}
									</div>
									<div className="form-group d-flex align-items-center">
										<label className="mr-3 mb-0" htmlFor="durationSwitch">
											Previous Comittes
										</label>
										<div className="custom-control custom-switch">
											<input
												type="checkbox"
												className="custom-control-input"
												id="durationSwitch"
												checked={isDurationEnabled}
												onChange={() => setIsDurationEnabled(prev => !prev)}
											/>
											<label className="custom-control-label" htmlFor="durationSwitch"></label>
										</div>
									</div>
									{isDurationEnabled && (
										<>
											{durationError && <div className="text-danger mt-2">{durationError}</div>}
											<div className="row">
												<div className="col-md-6">
													<div className="form-group">
														<label htmlFor="durationFrom">From (Year)</label>
														<input
															type="number"
															className="form-control"
															id="durationFrom"
															min="1900"
															max="2099"
															step="1"
															value={duration.from}
															onChange={e => {
																const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 4)
																setDuration(prev => ({
																	...prev,
																	from: val,
																}))
																setDurationError('')
															}}
														/>
														{durationError && !duration.from && (
															<div className="text-danger mt-1">From year is required</div>
														)}
													</div>
												</div>
												<div className="col-md-6">
													<div className="form-group">
														<label htmlFor="durationTo">To (Year)</label>
														<input
															type="number"
															className="form-control"
															id="durationTo"
															min="1900"
															max="2099"
															step="1"
															// placeholder="enter year"
															value={duration.to}
															onChange={e => {
																const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 4)
																setDuration(prev => ({
																	...prev,
																	to: val,
																}))
																setDurationError('')
															}}
														/>
														{durationError && !duration.to && (
															<div className="text-danger mt-1">To year is required</div>
														)}
													</div>
												</div>
												{/* {durationError && (
                        <div className="text-danger mt-2">{durationError}</div>
                      )} */}
											</div>
										</>
									)}
									<div className="modal-footer">
										<button className="btn btn-labeled btn-success" type="submit">
											<span className="btn-label">
												<i className="fa fa-check"></i>
											</span>
											{editMode ? 'Update' : 'Submit'}
										</button>
										<button
											className="btn btn-labeled btn-secondary ml-2"
											type="button"
											onClick={() => {
												setShowModal(false)
												setEditMode(false)
												setEditData(null)
												setFormData({
													firstName: '',
													lastName: '',
													email: '',
													mobile: '',
												})
												setSelectedPermissions({})
												// setMobileError("");
											}}
										>
											<span className="btn-label">
												<i className="fa fa-times"></i>
											</span>
											Cancel
										</button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default TableFilter
